import MobileFilters from '@/MainLayout/MobileFilters';
import { SearchInputWrapper } from '@/MainLayout/SearchHeader/SearchHeader.styles';
import { useKeywordSearch } from './hooks';
import KeywordSearch from './KeywordSearch';

type OwnProps = {
  isStickySearchBar: boolean;
};

export default function KeywordSearchWrapper({ isStickySearchBar }: OwnProps) {
  const { inputFocus, setInputFocus } = useKeywordSearch();

  const keywordSearchProps = {
    inputFocus,
    setInputFocus
  };

  return (
    <SearchInputWrapper>
      <KeywordSearch
        {...keywordSearchProps}
        isStickySearchbar={isStickySearchBar}
      />
      <MobileFilters isStickySearchBar={isStickySearchBar} />
    </SearchInputWrapper>
  );
}
